export function montoALetras(monto) {
    const unidades = ["", "UN", "DOS", "TRES", "CUATRO", "CINCO", "SEIS", "SIETE", "OCHO", "NUEVE"];
    const decenas = ["", "DIEZ", "VEINTE", "TREINTA", "CUARENTA", "CINCUENTA", "SESENTA", "SETENTA", "OCHENTA", "NOVENTA"];
    const especiales = {
        11: "ONCE", 12: "DOCE", 13: "TRECE", 14: "CATORCE", 15: "QUINCE",
        16: "DIECISEIS", 17: "DIECISIETE", 18: "DIECIOCHO", 19: "DIECINUEVE",
        21: "VEINTIUNO", 22: "VEINTIDOS", 23: "VEINTITRES", 24: "VEINTICUATRO", 25: "VEINTICINCO",
        26: "VEINTISEIS", 27: "VEINTISIETE", 28: "VEINTIOCHO", 29: "VEINTINUEVE"
    };
    const centenas = ["", "CIENTO", "DOSCIENTOS", "TRESCIENTOS", "CUATROCIENTOS", "QUINIENTOS", "SEISCIENTOS", "SETECIENTOS", "OCHOCIENTOS", "NOVECIENTOS"];

    function convertirGrupo(n) {
        let res = "";
        if (n === 100) return "CIEN";
        if (n > 100) {
            res += centenas[Math.floor(n / 100)] + " ";
            n %= 100;
        }
        if (n > 0) {
            if (especiales[n]) {
                res += especiales[n];
            } else {
                const d = Math.floor(n / 10);
                const u = n % 10;
                if (d > 0) {
                    res += decenas[d];
                    if (u > 0) res += " Y ";
                }
                if (u > 0) res += unidades[u];
            }
        }
        return res.trim();
    }

    const principal = Math.floor(monto);
    const centavos = Math.round((monto - principal) * 100);
    const centavosStr = centavos.toString().padStart(2, "0") + "/100";

    let letras = "";
    if (principal === 0) {
        letras = "CERO";
    } else if (principal < 1000) {
        letras = convertirGrupo(principal);
    } else {
        const miles = Math.floor(principal / 1000);
        const resto = principal % 1000;
        if (miles === 1) letras = "MIL ";
        else letras = convertirGrupo(miles) + " MIL ";
        if (resto > 0) letras += convertirGrupo(resto);
    }

    return `${letras.trim()} CON ${centavosStr} DÓLARES`;
}
